import { Fragment, lazy, Suspense, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { MINUTE } from '@hsp/utilities';

import { useCreateRouter } from 'hooks/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: MINUTE * 3,
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: MINUTE,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.groupCollapsed('QueryClient');
      // eslint-disable-next-line no-console
      console.error(error);
      // eslint-disable-next-line no-console
      console.groupEnd();
    },
  }),
});

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((module) => ({
    default: module.ReactQueryDevtools,
  }))
);

const AppRouter = () => {
  const [showDevtools, setShowDevtools] = useState(false);
  const router = useCreateRouter(queryClient);

  useEffect(() => {
    // @ts-expect-error Defining this function for production builds, to be able to turn on the react query dev tools
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Fragment>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
        {showDevtools && (
          <Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </Suspense>
        )}
      </Fragment>
    </QueryClientProvider>
  );
};

export default AppRouter;
